import dayjs from "dayjs";

import { CitizenWithAttendancesData } from "@/services/esus/citizen/getCitizenWithAttendances";
import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC1CitizenHistoryItem } from "./IndicatorEsfC1CitizenHistoryItem";
import { IndicatorEsfC1CitizenHistoryInfo } from "./IndicatorEsfC1CitizenHistoryInfo";

type IndicatorEsfC1CitizenHistoryProps = {
	citizenWithAttendances: CitizenWithAttendancesData;
};

export function IndicatorEsfC1CitizenHistory({
	citizenWithAttendances,
}: Readonly<IndicatorEsfC1CitizenHistoryProps>) {
	const indicatorEsfC1CitizenHistoryInfo = {
		fullName: citizenWithAttendances.fullName ? citizenWithAttendances.fullName : "N/A",
		birthdate: citizenWithAttendances.birthdate
			? dayjs(citizenWithAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithAttendances.birthdate
			? getAge(dayjs(citizenWithAttendances.birthdate))
			: "",
		document: citizenWithAttendances.cpf
			? formatIdentifier(citizenWithAttendances.cpf)
			: citizenWithAttendances.cns ?? "",
		motherName: citizenWithAttendances.citizenExtra?.motherName ?? "",
		phone: citizenWithAttendances.citizenExtra?.phone
			? phoneFormat(citizenWithAttendances.citizenExtra.phone)
			: "",
		address:
			addressConcat(
				citizenWithAttendances.citizenExtra?.street,
				citizenWithAttendances.citizenExtra?.houseNumber,
				citizenWithAttendances.citizenExtra?.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC1CitizenHistoryInfo {...indicatorEsfC1CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Atendimentos"
				timeLineContents={(citizenWithAttendances.attendances ?? []).map<TimeLineContent>(
					(attendance) => {
						return {
							content: <IndicatorEsfC1CitizenHistoryItem attendance={attendance} />,
							eventDate: attendance.date
								? dayjs(attendance.date).format("DD/MM/YYYY")
								: "N/A",
						};
					}
				)}
			/>
		</>
	);
}
